import { render, staticRenderFns } from "./CompanySdsExpirationForm.vue?vue&type=template&id=046ab360"
import script from "./CompanySdsExpirationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySdsExpirationForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanySdsExpirationForm.vue?vue&type=style&index=0&id=046ab360&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports